export enum ERTCHookName {
  STREAM = 'stream',
  DATA_CHANNEL_OPEN = 'data_channel_open',
  DATA_CHANNEL_MESSAGE = 'data_channel_message',
  RTT = 'rtt',
  CANDIDATE = 'candidate',
  STATUS_DATA = 'status_data',
  NETWORK_ERROR = 'network_error'
}

export enum ERTCEventType {
  CLIENT = '1'
}

export enum ERTCEventName {
  TOUCH = '_touch2',
  MOVE = '_move',
  INPUT = '_text',
  SYSTEM_KEY = '_key'
}

export type IRTCDataChannelSend = <T>(eventName: ERTCEventName, data: T) => void
